
import BottomNav from '../../components/base/BottomNav';
import Header from '../../components/base/Header';

export default function Relatorios() {
  const estatisticas = [
    { label: 'Mentorias Realizadas', valor: 48, meta: 50, icon: 'ri-message-3-line', color: 'from-blue-500 to-cyan-500' },
    { label: 'Horas de Estudo', valor: 127, meta: 150, icon: 'ri-time-line', color: 'from-purple-500 to-pink-500' },
    { label: 'Disciplinas Dominadas', valor: 8, meta: 10, icon: 'ri-book-line', color: 'from-green-500 to-emerald-500' },
    { label: 'Badges Conquistados', valor: 12, meta: 20, icon: 'ri-trophy-line', color: 'from-amber-500 to-orange-500' },
  ];

  const disciplinas = [
    { nome: 'Matemática', progresso: 85, cor: 'bg-blue-500' },
    { nome: 'Física', progresso: 72, cor: 'bg-purple-500' },
    { nome: 'Química', progresso: 68, cor: 'bg-green-500' },
    { nome: 'Programação', progresso: 91, cor: 'bg-orange-500' },
    { nome: 'Inglês', progresso: 78, cor: 'bg-pink-500' },
  ];

  const atividades = [
    { tipo: 'Mentoria', titulo: 'Cálculo Diferencial', mentor: 'João Pedro Santos', data: 'Hoje, 14:30', icon: 'ri-message-3-line', color: 'text-blue-500', bg: 'bg-blue-100' },
    { tipo: 'Conquista', titulo: 'Badge "Sequência de 7 Dias"', mentor: 'Sistema', data: 'Hoje, 09:15', icon: 'ri-trophy-line', color: 'text-amber-500', bg: 'bg-amber-100' },
    { tipo: 'Resgate', titulo: 'Notebook Ecológico', mentor: 'Loja Sustentável', data: 'Ontem, 16:45', icon: 'ri-gift-line', color: 'text-green-500', bg: 'bg-green-100' },
    { tipo: 'Mentoria', titulo: 'Física Quântica', mentor: 'Ana Carolina Lima', data: 'Ontem, 10:00', icon: 'ri-message-3-line', color: 'text-purple-500', bg: 'bg-purple-100' },
  ];

  return (
    <div className="min-h-screen bg-gradient-to-br from-pink-50 via-purple-50 to-blue-50 pb-20">
      <Header title="Relatórios" />

      <div className="pt-16 px-6">
        {/* Resumo Mensal */}
        <div className="mt-4 bg-gradient-to-r from-pink-500 to-purple-500 rounded-3xl shadow-lg p-6 text-white">
          <h2 className="text-xl font-bold mb-2">Resumo do Mês</h2>
          <p className="text-sm opacity-90 mb-4">Dezembro 2024</p>
          <div className="grid grid-cols-2 gap-4">
            <div>
              <div className="text-3xl font-bold">48</div>
              <div className="text-sm opacity-90">Mentorias</div>
            </div>
            <div>
              <div className="text-3xl font-bold">1,250</div>
              <div className="text-sm opacity-90">Pontos Ganhos</div>
            </div>
          </div>
        </div>

        {/* Estatísticas */}
        <div className="mt-6">
          <h3 className="text-lg font-bold text-gray-800 mb-3">Suas Estatísticas</h3>
          <div className="space-y-4">
            {estatisticas.map((stat, index) => (
              <div key={index} className="bg-white rounded-2xl shadow-md p-5">
                <div className="flex items-center gap-4 mb-3">
                  <div className={`w-12 h-12 flex items-center justify-center bg-gradient-to-br ${stat.color} rounded-xl flex-shrink-0`}>
                    <i className={`${stat.icon} text-xl text-white`} />
                  </div>
                  <div className="flex-1">
                    <h4 className="font-bold text-gray-800">{stat.label}</h4>
                    <p className="text-sm text-gray-600">
                      {stat.valor} de {stat.meta}
                    </p>
                  </div>
                  <div className="text-2xl font-bold text-gray-800">{stat.valor}</div>
                </div>
                <div className="flex items-center gap-3">
                  <div className="flex-1 bg-gray-200 rounded-full h-2">
                    <div
                      className={`bg-gradient-to-r ${stat.color} h-2 rounded-full transition-all`}
                      style={{ width: `${(stat.valor / stat.meta) * 100}%` }}
                    />
                  </div>
                  <span className="text-sm font-semibold text-gray-600">
                    {Math.round((stat.valor / stat.meta) * 100)}%
                  </span>
                </div>
              </div>
            ))}
          </div>
        </div>

        {/* Progresso por Disciplina */}
        <div className="mt-6">
          <h3 className="text-lg font-bold text-gray-800 mb-3">Progresso por Disciplina</h3>
          <div className="bg-white rounded-2xl shadow-md p-5 space-y-4">
            {disciplinas.map((disciplina, index) => (
              <div key={index}>
                <div className="flex items-center justify-between mb-2">
                  <span className="font-semibold text-gray-800">{disciplina.nome}</span>
                  <span className="text-sm font-bold text-gray-600">{disciplina.progresso}%</span>
                </div>
                <div className="bg-gray-200 rounded-full h-2">
                  <div
                    className={`${disciplina.cor} h-2 rounded-full transition-all`}
                    style={{ width: `${disciplina.progresso}%` }}
                  />
                </div>
              </div>
            ))}
          </div>
        </div>

        {/* Atividades Recentes */}
        <div className="mt-6 mb-6">
          <h3 className="text-lg font-bold text-gray-800 mb-3">Atividades Recentes</h3>
          <div className="space-y-3">
            {atividades.map((atividade, index) => (
              <div key={index} className="bg-white rounded-2xl shadow-md p-4 flex items-start gap-4">
                <div className={`w-12 h-12 flex items-center justify-center ${atividade.bg} rounded-xl flex-shrink-0`}>
                  <i className={`${atividade.icon} text-xl ${atividade.color}`} />
                </div>
                <div className="flex-1">
                  <div className="flex items-center gap-2 mb-1">
                    <span className="text-xs font-semibold text-gray-500 uppercase">
                      {atividade.tipo}
                    </span>
                  </div>
                  <h4 className="font-bold text-gray-800 mb-1">{atividade.titulo}</h4>
                  <p className="text-sm text-gray-600">{atividade.mentor}</p>
                  <p className="text-xs text-gray-500 mt-1">{atividade.data}</p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>

      <BottomNav />
    </div>
  );
}
